export default function SearchMenuIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={Math.round((size * 36) / 37)}
        viewBox='0 0 37 36'
        fill='currentColor'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M9.05548 22.4155C5.22788 18.5879 5.22788 12.3821 9.05548 8.5545C12.8831 4.7269 19.0888 4.7269 22.9164 8.5545C26.744 12.3821 26.744 18.5879 22.9164 22.4155C19.0888 26.2431 12.8831 26.2431 9.05548 22.4155ZM7.7157 7.21472C3.14815 11.7823 3.14815 19.1877 7.7157 23.7553C11.5748 27.6144 17.4598 28.2129 21.9474 25.5509L27.0611 30.6646C28.1943 31.7978 30.0315 31.7978 31.1647 30.6646C32.2978 29.5315 32.2978 27.6942 31.1647 26.5611L26.0512 21.4475C28.714 16.9599 28.1157 11.0742 24.2562 7.21472C19.6887 2.64718 12.2832 2.64718 7.7157 7.21472ZM24.9376 23.0135C24.723 23.268 24.4959 23.5156 24.2562 23.7553C24.0162 23.9953 23.7684 24.2227 23.5135 24.4374L28.4009 29.3248C28.7941 29.7181 29.4317 29.7181 29.8249 29.3248C30.2181 28.9316 30.2181 28.2941 29.8249 27.9008L24.9376 23.0135Z'
        />
      </svg>
    </span>
  );
}
